import { Box, SxProps, Typography } from '@mui/material'

import { ModalWrapProps } from 'common/interfaces'
import { deleteBtnStyle } from 'common/styles'
import ModalActionCancelButtons from 'components/Modals/components/ModalActionCancelButtons'
import ModalWrap from 'components/ModalWrap'

type DeleteAppendedItemModalProps = Pick<ModalWrapProps, 'open' | 'onClose' | 'title'> & {
  onDelete: () => void
}

const wrapStyle: SxProps = {
  marginBottom: {
    xs: '24px',
    md: '16px',
  },
}

export default function DeleteAppendedItemModal({
  open,
  onClose,
  title,
  onDelete,
}: DeleteAppendedItemModalProps): JSX.Element {
  return (
    <ModalWrap
      title={`Are you sure you want to delete this ${title!}?`}
      onClose={onClose}
      open={open}
      actions={
        <ModalActionCancelButtons
          actionHandler={onDelete}
          onClose={onClose}
          textAction={`Delete ${title!}`}
          textCancel="Cancel"
          actionStyle={deleteBtnStyle}
        />
      }
    >
      <Box display="flex" sx={wrapStyle}>
        <Typography>
          This will remove all of your entered data, and unfortunately, this action cannot be
          reversed.
        </Typography>
      </Box>
    </ModalWrap>
  )
}
